"use strict";

import $ from "jquery";

export default function mobile(scope) {
    const mobileToggle = $(scope + "-toggle");
    const mobileWrapper = $(scope + "-wrapper");

    mobileToggle.on("click", function () {
        $("body").toggleClass("has-mobile-nav");
    });

    mobileWrapper.on("click", "a", function () {
        $("body").removeClass("has-mobile-nav");
    });
}
